import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import ReceivingHistory from 'components/Reports/ReceivingHistory';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <ReceivingHistory />
      </SiteContent>
    </ContentLayout>
  );
};
